module.exports = __webpack_public_path__ + "img/diy3.dd39afb8.png";